// Bharat Ayurveda — global.js (vanilla JS, no build step)

document.addEventListener('DOMContentLoaded', function () {

  /* ---------- Mobile nav ---------- */
  var navToggle = document.querySelector('[data-nav-toggle]');
  var mainNav = document.querySelector('[data-main-nav]');
  if (navToggle && mainNav) {
    navToggle.addEventListener('click', function () {
      mainNav.classList.toggle('is-open');
    });
  }

  /* ---------- Accordions (product page) ---------- */
  document.querySelectorAll('.accordion-trigger').forEach(function (btn) {
    btn.addEventListener('click', function () {
      btn.closest('.accordion-item').classList.toggle('is-open');
    });
  });

  /* ---------- Quantity steppers ---------- */
  document.querySelectorAll('[data-qty-wrapper]').forEach(function (wrapper) {
    var input = wrapper.querySelector('input');
    wrapper.querySelectorAll('[data-qty-step]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var step = parseInt(btn.getAttribute('data-qty-step'), 10);
        var val = Math.max(1, (parseInt(input.value, 10) || 1) + step);
        input.value = val;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  /* ---------- Product gallery thumbs ---------- */
  document.querySelectorAll('[data-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var mainImg = document.querySelector('[data-gallery-main]');
      if (mainImg) mainImg.src = thumb.getAttribute('data-full');
      document.querySelectorAll('[data-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
    });
  });

  /* ---------- Cart drawer ---------- */
  var cartDrawer = document.querySelector('[data-cart-drawer]');
  var cartOverlay = document.querySelector('[data-cart-overlay]');

  function openCart() {
    if (cartDrawer) cartDrawer.classList.add('is-open');
    if (cartOverlay) cartOverlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    if (cartDrawer) cartDrawer.classList.remove('is-open');
    if (cartOverlay) cartOverlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  document.querySelectorAll('[data-cart-open]').forEach(function (el) {
    el.addEventListener('click', function (e) { e.preventDefault(); openCart(); });
  });
  document.querySelectorAll('[data-cart-close]').forEach(function (el) {
    el.addEventListener('click', function (e) { e.preventDefault(); closeCart(); });
  });
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
  }

  function renderCartDrawer(cart) {
    var itemsEl = document.querySelector('[data-cart-items]');
    var subtotalEl = document.querySelector('[data-cart-subtotal]');
    if (!itemsEl) return;

    if (cart.item_count === 0) {
      itemsEl.innerHTML = '<div class="cart-empty"><p>Your cart is empty.</p></div>';
    } else {
      itemsEl.innerHTML = cart.items.map(function (item) {
        return '' +
          '<div class="cart-line">' +
            '<img src="' + item.image + '" alt="' + item.product_title + '">' +
            '<div class="cart-line-info">' +
              '<h4>' + item.product_title + '</h4>' +
              (item.variant_title ? '<div class="variant">' + item.variant_title + '</div>' : '') +
              '<div class="qty-input" data-qty-wrapper>' +
                '<button type="button" data-qty-step="-1" data-line-key="' + item.key + '">–</button>' +
                '<span>' + item.quantity + '</span>' +
                '<button type="button" data-qty-step="1" data-line-key="' + item.key + '">+</button>' +
              '</div>' +
            '</div>' +
            '<div>' + formatMoney(item.final_line_price) + '</div>' +
          '</div>';
      }).join('');
    }
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
    updateCartCount(cart.item_count);

    itemsEl.querySelectorAll('[data-qty-step]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.getAttribute('data-line-key');
        var dir = parseInt(btn.getAttribute('data-qty-step'), 10);
        var currentLine = cart.items.find(function (i) { return i.key === key; });
        var newQty = Math.max(0, currentLine.quantity + dir);
        changeLineQuantity(key, newQty);
      });
    });
  }

  function formatMoney(cents) {
    return '₹' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }

  function fetchCart() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(renderCartDrawer);
  }

  function changeLineQuantity(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) { return r.json(); }).then(function (cart) {
      renderCartDrawer(cart);
    });
  }

  // Add to cart (main product form + quick add)
  document.querySelectorAll('[data-add-to-cart-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var submitBtn = form.querySelector('[type="submit"]');
      var originalText = submitBtn ? submitBtn.textContent : '';
      if (submitBtn) { submitBtn.textContent = 'Adding…'; submitBtn.disabled = true; }

      var formData = new FormData(form);
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: formData
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
            renderCartDrawer(cart);
            openCart();
          });
        })
        .catch(function () {
          if (submitBtn) submitBtn.textContent = 'Something went wrong';
        })
        .finally(function () {
          if (submitBtn) { submitBtn.textContent = originalText; submitBtn.disabled = false; }
        });
    });
  });

  // Initial cart state on load
  fetchCart();
});
